// JS for Giftcard Product page

import { FormHelper } from "./webcomponents/form-helper.js";
import { ImageCarousel } from "./webcomponents/image-carousel.js";
import { TrainInfoCard } from "./webcomponents/train-info-card.js";
import { SubmitStatus } from "./webcomponents/submit-status.js";
import { SetElementsDisabled, SetElementsVisible, WireupHandlers } from "./lib/data-wireup.js";

// Register required webcomponents
FormHelper.Register();
ImageCarousel.Register();
TrainInfoCard.Register();
SubmitStatus.Register();

window.addEventListener("DOMContentLoaded", async () => {
    const formHelper = document.querySelector("form-helper");

    // Stick the custom amount in the right place
    formHelper.transformer = (formdata) => {
        if (formdata?.Amount === "other") {
            formdata.Amount = formdata.Custom;
        }
        delete formdata.Custom;
    };

    // Initial purchase fee display
    const amountInput = document.querySelector("[data-wireup-amount]");
    if (amountInput) UpdatePurchaseFee(amountInput.value);

    // Show/hide other amount field
    WireupHandlers("amount", "change", async (e) => {
        SetElementsVisible("otheramount", e.target.value === "other");
        // Don't validate the "other amount" field if it's hidden
        SetElementsDisabled("otheramount", e.target.value !== "other");
        if (e.target.value === "other") {
            const otherInput = document.querySelector("[data-wireup-otheramount]");
            if (otherInput) UpdatePurchaseFee(otherInput.value);
        } else {
            UpdatePurchaseFee(e.target.value);
        }
    });

    WireupHandlers("otheramount", "input", async (e) => {
        UpdatePurchaseFee(e.target.value);
    });

    function UpdatePurchaseFee(value) {
        const fees = document.querySelectorAll("[data-wireup-purchasefee]");
        for (const fee of fees) {
            if (Number(fee.dataset["from"] || 0) <= value && Number(fee.dataset["to"] || Infinity) >= value) {
                fee.classList.remove("hidden");
            } else {
                fee.classList.add("hidden");
            }
        }
    }
});
